import type { Variable } from "./variablesTypes";

const normalizeString = (value: unknown): string => {
  if (typeof value === "string") {
    return value;
  }
  if (typeof value === "number" || typeof value === "boolean") {
    return String(value);
  }
  return "";
};

/** Converts persisted release variable data into values safe for the variables UI. */
export const normalizeVariables = (value: unknown): Variable[] => {
  if (!Array.isArray(value)) {
    return [];
  }

  return value.flatMap((item): Variable[] => {
    if (typeof item !== "object" || item === null) {
      return [];
    }

    const candidate = item as Record<string, unknown>;
    if (typeof candidate.id !== "string" || candidate.id.trim() === "") {
      return [];
    }

    return [
      {
        id: candidate.id,
        key: normalizeString(candidate.key),
        value: normalizeString(candidate.value),
        created: normalizeString(candidate.created),
        lastModified: normalizeString(candidate.lastModified),
      },
    ];
  });
};
